<template>
  <aside class="main" v-if="ready && date && time">
    <button type="button" class="content" @click="openScheduling">
      <span class="eyebrow">Next Available Appointment</span>
      <span class="date">{{ date }}</span>
      <span class="time">{{ time }}</span>
    </button>
  </aside>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import Services from '../mixins/services';
import moment from "moment";
import SchedulingModal from './../components/location-search/scheduling-modal';

export default {
  mixins: [Services],
  props: {
    clinicId: {
      type: String,
      required: true,
    },
    dealerId: {
      type: String,
      required: true,
    }
  },
  data: function () {
    return {
      ready: false,
      date: null,
      time: null
    }
  },
  computed: mapState({
    clientToken: state => state.ClientToken.clientToken,
    nextAvailableAppointment: state => state.NextAvailable.nextAvailableAppointment,
    clinicUrl: state => state.NextAvailable.clinicUrl,
  }),
  methods: {
    ...mapActions('ClientToken', {getClientToken: 'getClientToken'}),
    ...mapActions('NextAvailable', {getInformation: 'getInformation'}),
    openScheduling() {
      SchedulingModal.open({ dealerId: this.dealerId, clinicUrl: this.clinicUrl });
    },
  },
  mounted() {
    this.getClientToken({
      cb: () => {
        this.getInformation({
          clinicId: this.clinicId,
          dealerId: this.dealerId,
          clientToken: this.clientToken,
          cb: () => {
            if (this.nextAvailableAppointment !== '0001-01-01T00:00:00') {
              this.date = moment(this.nextAvailableAppointment).format("dddd MMM. Do");
              this.time = moment(this.nextAvailableAppointment).format("h:mm A");
              this.ready = true;
            }
          }
        });
      }
    })
  }
}
</script>
